import * as types from './mutations-types'
import { VISIT_TYPE_IN_PERSON_VALUE } from '@/views/constants'

export default {
  [types.SET_FORM_DATA] (state, formData) {
    state.formData = { ...state.formData, ...formData }
  },
  [types.RESET_FORM_DATA] (state) {
    state.formData = {
      isTelehealth: VISIT_TYPE_IN_PERSON_VALUE,
      areUserThePatient: null
    }
  }
}
